import { render } from "./payroll-delete-modal.vue?vue&type=template&id=8e4021be"
import script from "./payroll-delete-modal.vue?vue&type=script&lang=js"
export * from "./payroll-delete-modal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__